import {ReactElement} from "react";
import {Button, Card, Form, FormInstance, Input, Select, Space, Table} from "antd";
import {Custom, keyedObject} from "../../utils/refineUtils";
import {PlusOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";

interface IProps {
    isEditable?: boolean
    index?: any,
    form?: FormInstance<{}>
}

export default function ConfigLAVirtualLabs(props: IProps): ReactElement | null {

    return (
        <Space direction="vertical" size="small" style={{width: "100%"}}>
            <Custom.Title title="Séléction des salles">
                <Link style={{fontSize: "small"}} to="./exercices">Gérer les salles</Link>
            </Custom.Title>
            <Form.Item style={{marginBottom: 0}} name={[props?.index, 'config', 'exercises']} initialValue={props?.isEditable ? [] : undefined}>
                <Table size="small"/>
            </Form.Item>
        </Space>
    )
}